import styled from "styled-components";
import { Button } from "@mui/material";

export const Btn = styled(Button)`
  border-radius: 22px !important;
  display: flex;
  width: max-content !important;
  min-width: 100% !important;
  text-transform: none !important;

  span {
    padding-right: 0.5em;
    text-transform: none;
  }

  :hover {
    opacity: 0.6;
  }
`;

export const Text = styled.p`
  font-weight: 700;
  font-size: 14px;
  color: #000000;
  margin: 0;
  padding-bottom: 0.7em;
`;

export const Bold = styled.h3`
  font-weight: 700;
  font-size: 32px;
  color: #000000;
  margin: 0;

  span {
    padding-left: 0.3em;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
  }
`;

export const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 1em;
  z-index: 2;
`;

export const ModalButtonArea = styled.div`
  gap: 10px;
  display: flex;
  justify-content: flex-end;
  margin-top: 1.7em;

  button {
    background: grey;
    border: 0;
    color: white;
    font-size: 14px;
    border-radius: 6px;
    padding: 0.8em 1.6em;

    :hover {
      opacity: 0.6;
    }

    :active {
      outline: 3px solid lightgrey;
    }

    :first-child {
      background: var(--main-color);
    }
  }
`;

export const BtnAction = styled.span`
  background-color: #da45f8;
  color: white;
  border-radius: 50px;
  padding: 0.5em 1em;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  justify-content: center;
  width: max-content;
  font-size: 13px;

  :hover {
    opacity: 0.6;
  }

  :active {
    outline: 1px solid lightgrey;
  }
`;

export const Badge = styled.span`
  background-color: #cce6ff;
  display: block;
  color: #0080ff;
  width: max-content;
  padding: 0.4em 0.8em;
  border-radius: 22px;
`;
